"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceContainer = exports.Purchased = exports.LoadingPrice = exports.BuyButton = exports.Description = exports.Platform = exports.Title = exports.CardContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const LicensePrice_1 = require("../LicensePrice");
const Offer_1 = require("../Offer");
const Offline_1 = require("../Offline");
const styled_components_1 = __importStar(require("styled-components"));
const SecondaryButton_1 = require("../../atoms/SecondaryButton");
const store_1 = require("../../utils/store");
function CardContent({ license, onBuy }) {
    const { product } = license;
    const { isWindows } = (0, device_1.usePlatform)();
    const licenseStrings = (0, store_1.stringsForLicenseType)(license.type);
    const title = (0, i18n_1.Localized)(licenseStrings.name);
    const platform = (0, i18n_1.Localized)(licenseStrings.platform);
    const description = (0, i18n_1.Localized)(licenseStrings.shortDescription);
    const isOffline = (0, device_1.useIsDeviceOffline)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.Title, { "data-e2e": 'CardContent_Title', children: title }), (0, jsx_runtime_1.jsx)(exports.Platform, { "data-e2e": 'CardContent_Platform', children: platform }), (0, jsx_runtime_1.jsx)(exports.Description, { "data-e2e": 'CardContent_Description', children: description }), license.isPurchased ? ((0, jsx_runtime_1.jsx)(exports.Purchased, { "data-e2e": 'CardContent_Purchased', children: (0, i18n_1.Localized)(i18n_1.Strings.store.youSubscribed) })) : product ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Offer_1.Offer, { product: product, "data-e2e": 'CardContent_Offer' }), (0, jsx_runtime_1.jsx)(exports.PriceContainer, { "data-e2e": 'CardContent_PriceContainer', children: (0, jsx_runtime_1.jsx)(LicensePrice_1.LicensePrice, { license: license, "data-e2e": 'CardContent_LicensePrice' }) }), (0, jsx_runtime_1.jsxs)(exports.BuyButton, { disabled: isOffline, onClick: onBuy, "data-e2e": 'CardContent_BuyButton', children: [(0, i18n_1.Localized)(i18n_1.Strings.store.buyNow), isWindows && (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.New_Window, "data-e2e": 'CardContent_StyledIcon' })] })] })) : ((0, jsx_runtime_1.jsx)(exports.LoadingPrice, { "data-e2e": 'CardContent_LoadingPrice', children: (0, i18n_1.Localized)(i18n_1.Strings.store.loadingPrice) })), isOffline && (0, jsx_runtime_1.jsx)(Offline_1.Offline, { "data-e2e": 'CardContent_Offline' })] }));
}
exports.CardContent = CardContent;
exports.Title = styled_components_1.default.div `
  margin: ${props => props.centered ? '0 auto 5px auto' : '20px auto 5px auto'};

  color: ${props => props.theme.text};

  font-size: 24px;
  text-align: center;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    font-size: 20px;
  `)}
`;
exports.Platform = styled_components_1.default.div `
  margin: 0 auto;

  color: ${props => props.theme.text};

  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
`;
exports.Description = styled_components_1.default.div `
  max-width: 180px;

  margin: 20px auto 0 auto;

  color: ${props => props.theme.textSecondary};

  font-size: 14px;
  text-align: center;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin: 20px auto 0 auto;
  `)}

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin: auto 20px;
  `)}
`;
exports.BuyButton = (0, styled_components_1.default)(SecondaryButton_1.SecondaryButton) `
  flex-shrink: 0;

  width: 160px;

  margin: auto auto 20px auto;
  padding: 12px 0;

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: auto auto 10px auto;
  `)}
`;
exports.LoadingPrice = styled_components_1.default.div `
  margin: auto auto 60px auto;

  color: ${props => props.theme.disabledSecondary};

  font-size: 16px;
  font-style: italic;
`;
exports.Purchased = styled_components_1.default.div `
  margin: auto auto 30px auto;

  color: ${props => props.theme.text};

  font-size: 11px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin: auto auto 30px auto;
  `)}
`;
exports.PriceContainer = styled_components_1.default.div `
  display: flex;

  width: 100%;

  margin: auto;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 14px;
  height: 14px;
  margin: 0 auto 0 10px;

  color: ${props => props.theme.greenSecondary};
`;
